import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';

export const cardAccessibilityWrap = () => {
  Alpine.data('cardAccessibilityWrap', () => ({
    card: false,
    cardLink: '',
    cardUrl: '',
    cardTarget: '',
    init() {
      this.card = this.$el;
      this.cardLink = this.card.querySelector('.m-card__link');
      if (this.cardLink) {
        this.cardUrl = this.cardLink.getAttribute('href');
        // Set the card target if it exists.
        this.cardTarget = this.cardLink.getAttribute('target');
      }

      this.makeCardAccessible();
    },
    makeCardAccessible() {
      if (this.cardLink) {
        this.card.classList.add('m-card--hover');
      }
    },
    bindCard: {
      // eslint-disable-next-line func-names
      '@click.prevent': function () {
        if (this.cardLink) {
          if (this.cardLink.classList.contains('use-ajax')) {
            // It's an AJAX link, simulate a click.
            this.cardLink.click();
          } else if (this.cardTarget === '_blank') {
            // Open in a new tab if target is _blank.
            window.open(this.cardUrl, '_blank', 'noopener,noreferrer');
          } else {
            // Not AJAX or _blank, use window.location to redirect in the same tab.
            window.location.href = this.cardUrl;
          }
        }
      },
    },
    bindCardLink: {
      // eslint-disable-next-line func-names
      '@focus': function () {
        if (this.cardLink) {
          this.card.classList.add('m-card--focused');
        }
      },
      // eslint-disable-next-line func-names
      '@blur': function () {
        if (this.cardLink) {
          this.card.classList.remove('m-card--focused');
        }
      },
    },
  }));
};
